import React from 'react';
import { useEffect, useState } from 'react';

import { Table, Tab, Tabs, Button } from 'react-bootstrap';

import useRequest from '../helper/useRequest';
import { formatDate } from '../helper/DateTimeFormater';
import { toast } from 'react-toastify';
import Loader from '../helper/Loader';
import { utils, writeFileXLSX } from "xlsx";


const monthNames = ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"];

const Tablerow = (props) => {
    if (!props) return null;

    return <tr>
        <td>{props.entry.OrganisationName}</td>
        <td>{props.entry.Address}</td>
        <td>{formatDate(props.entry.Start)}</td>
        <td>{formatDate(props.entry.End)}</td>
        <td>{props.entry.Contingent}</td>
        <td>{props.entry.AmountTimeslots}</td>
        <td style={{ width: "240px", textAlign: "right" }}>
            <Button href={"/Operator/Business/" + props.entry.OrganisationID} size="sm" variant="primary">Details</Button>
        </td>
    </tr>
}

function Abos() {
    const { request } = useRequest();

    const [monthContingent, setMonthContingent] = useState([]);
    const [key, setKey] = useState('month-' + (new Date().getMonth()));


    const excelExport = () => {
        const workbook = utils.book_new();

        let table, sheet;
        for (let i = 0; i < monthNames.length; i++) {
            table = document.getElementById("abomonth-" + i);
            sheet = utils.table_to_sheet(table);
            utils.book_append_sheet(workbook, sheet, monthNames[i]);
        }

        writeFileXLSX(workbook, "Abo Export.xlsx");
    };

    useEffect(() => {
        const getContingents = async () => {
            try {
                let result = await request("/Operator/GetContingents");
                let json = result.data;
                if (json.r != 1) {
                    if (json.message) {
                        toast.info(json.message);
                    }
                    else {
                        toast.error("Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut");
                    }
                }
                else {
                    setMonthContingent(json.monthContingent);
                }
            }
            catch (ex) {
                toast.error("Laden der Termine fehlgeschlagen.");
            }
        };

        getContingents();
    }, []);

    if (monthContingent.length == 0) return <Loader />;

    return (
        <>
            <Button className="mb-2" variant="primary" onClick={() => excelExport()}>Excel Export</Button>
            <Tabs
                id="contingent-tab"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >
                {monthContingent.map((item, index) => {
                    return (
                        <Tab key={index} eventKey={"month-" + index} title={monthNames[index ]}>
                            <div className="timeslots">
                                <Table id={"abomonth-" + index} striped>
                                    <thead>
                                        <tr>
                                            <th>Organisation</th>
                                            <th>Adresse</th>
                                            <th>Start</th>
                                            <th>Ende</th>
                                            <th>Kontingent</th>
                                            <th>Anzahl gebuchter Zeitsätze</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {item != null && (item.map((entry, pos) => {
                                            return <Tablerow key={pos} entry={entry} />
                                        }))}
                                    </tbody>
                                </Table>
                            </div>
                        </Tab>
                    );
                })}
            </Tabs>           
        </>
    );
}

export default Abos;